import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { getLang } from 'shared/store/selectors/lang.selector';
import { DatePicker, toDateBound } from 'src/components/design-system';

const DATE_FMT = 'yyyy-MM-dd';

const toDatePickerValue = ymd => (ymd ? DateTime.fromFormat(ymd, DATE_FMT).toISO() : undefined);

export function ReportDateRange({ from, until, onChange }) {
  const lang = useSelector(getLang('EDUCATIONAL_EVENTS'));

  // Each picker bounds the other so an inverted range can't be selected at all —
  // the invalid days are disabled in the calendar rather than rejected after the fact.
  const bounds = { format: DATE_FMT };

  return (
    <>
      <DatePicker
        label={lang.REPORT_FROM_DATE}
        value={toDatePickerValue(from)}
        allowClear={false}
        maxDate={toDateBound(until, bounds)}
        onChange={next => next && onChange({ from: next.toFormat(DATE_FMT) })}
      />
      <DatePicker
        label={lang.REPORT_UNTIL_DATE}
        value={toDatePickerValue(until)}
        allowClear={false}
        minDate={toDateBound(from, bounds)}
        onChange={next => next && onChange({ until: next.toFormat(DATE_FMT) })}
      />
    </>
  );
}
